import { ComponentsOverrides } from "@mui/material";

const styleOverrides: ComponentsOverrides["MuiTextField"] = {
  root: {
    marginTop: "8px",
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: "#f44336",
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: "#f44336 !important",
    },
    "& label.Mui-focused": {
      color: "#6d9c15",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#6d9c15",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#6d9c15",
      },
      "&:hover fieldset": {
        borderColor: "#6d9c15",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#6d9c15",
      },
    },
  },
};

const StyledTextField = {
  styleOverrides,
};

export default StyledTextField;
